export default __webpack_public_path__ + "static/media/img_baseRattle_grey_p.0a6dc756.jpg";